import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    ingresoEgresoCuota: {},

    periodo: moment(new Date()).format('YYYY-MM-DD'),
    periodoDia: 1,
    periodoMes: 0,
    periodoMesNombre: null,
    periodoAnio: 0,
    importe: 0,
    observaciones: ''
};

const mutations = {
    updateField,

    'INICIALIZAR_CUOTA' (state) {
        let fecha = moment.utc(new Date()).format('YYYY-MM-DD');

        state.ingresoEgresoCuota = {};

        state.periodo = fecha;
        state.periodoMes= new Date(fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(fecha).getFullYear();
        state.importe = 0;
        state.observaciones = '';
    },
    'SET_CUOTA' (state, ingresoEgresoCuota) {
        state.ingresoEgresoCuota = ingresoEgresoCuota;

        state.periodo = ingresoEgresoCuota.periodo;
        state.periodoMes= new Date(ingresoEgresoCuota.periodo).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(ingresoEgresoCuota.periodo).getFullYear();
        state.importe = parseFloat(ingresoEgresoCuota.importe);
        state.observaciones = ingresoEgresoCuota.observaciones.trim();
    },
};

const getters = {
    getField,

    ingresoEgresoCuota (state) {
        return state.ingresoEgresoCuota;
    },
};

const actions = {
    inicializar ( { commit }, ingresoEgresoCuota ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CUOTA');

            if (ingresoEgresoCuota) {
                commit('SET_CUOTA', ingresoEgresoCuota);
                resolve();
            } else {
                resolve();
            }
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let periodo = parseInt(state.periodoAnio).toString().trim()
                + '-' + helpers.methods.getMesNumeroToString(state.periodoMesNombre).trim()
                + '-01';

            let item = {
                periodo,
                importe: parseFloat(state.importe),
                observaciones: state.observaciones.trim()
            }
            
            commit('SET_CUOTA', item);
            resolve()
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}